<template>
  <page-heading class="page-heading-workspace-settings" :crumbs="crumbs" />
</template>

<script lang="ts" setup>
  import PageHeading from '@/components/PageHeading.vue'

  const crumbs = [{ text: 'Settings' }]
</script>